import './ProjectUnitMix.css';

export default function ProjectUnitMix({ project }) {
  const { unitMix, unitCountLabel } = project;
  if (!unitMix || !unitMix.length) return null;

  return (
    <section className="pd-section pd-section--alt">
      <div className="pd-section__inner pd-unitmix">
        <div className="pd-unitmix__head">
          <p className="pd-eyebrow">Residences</p>
          <h2 className="pd-title">Unit <em>mix</em></h2>
          {unitCountLabel && (
            <p className="pd-unitmix__total">{unitCountLabel}</p>
          )}
        </div>

        <ul className="pd-unitmix__list">
          {unitMix.map((unit) => (
            <li key={unit.type} className="pd-unitmix__row">
              <span className="pd-unitmix__count">{unit.count}</span>
              <span className="pd-unitmix__type">{unit.type}</span>
              {unit.size && <span className="pd-unitmix__size">{unit.size}</span>}
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
